import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import F1 from "../assets/s11.png";
import F2 from "../assets/s22.png";
import F3 from "../assets/s33.png";
import F4 from "../assets/s44.png";
import F5 from "../assets/s55.png";
import F6 from "../assets/s66.png";

const NuestrosServicios = () => {
  const navigate = useNavigate();

  const services = [
    { name: "Asesoría Fiscal", src: F1 },
    { name: "Asesoría Legal", src: F2 },
    { name: "Asesoría Contable", src: F3 },
    { name: "Asesoría Administrativa", src: F4 },
    { name: "Asesoría en Psicología Empresarial", src: F5 },
    { name: "Asesoría y Desarrollo de Software", src: F6 },
  ];

  const handleClick = () => {
    navigate("/services");
  };

  return (
    <div className="pt-12">
      <motion.h2
        className="text-purple-900 text-5xl text-center font-semibold mb-8"
        initial={{ y: -50, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        transition={{ duration: 1 }}
        viewport={{ once: true }}
      >
        Nuestros servicios
      </motion.h2>
      <button
        onClick={handleClick}
        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 px-4 md:px-8"
      >
        {services.map((service, index) => (
          <motion.div
            key={index}
            className="relative rounded-xl overflow-hidden shadow-lg"
            initial={{ y: 50, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: index * 0.2 }}
            viewport={{ once: true }}
          >
            <img
              src={service.src}
              alt={service.name}
              className="w-full h-64 md:h-72 object-cover"
            />
            <div className="absolute bottom-0 w-full bg-transparent bg-opacity-80 p-4 text-center">
              <h3 className="text-white font-semibold text-lg">
                {service.name}
              </h3>
            </div>
          </motion.div>
        ))}
      </button>
    </div>
  );
};

export default NuestrosServicios;
